import React, { useEffect, useState } from "react";
import { Button } from "antd";
import SisLoader from "../../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../../widgets/AppToast";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import AddCoptDetailsModal from "../../components/CargoCraneCom/AddCoptDetailsModal";
import CoptTable from "../../components/CargoCraneCom/CoptRow";

function Copt({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errors, set_errors] = useState({});

  // List COPT API
  const listCoptData = () => {
    const formData = new FormData();
    formData.append("ship_id", id);
    try {
      post(ApiURL.list_copt_details, formData).then((res) => {
        if (res?.status === true) {
          setFilteredData(res?.response_data || []);
        }
      });
    } catch (error) {
      console.error("Error fetching COPT list:", error);
    }
  };

  useEffect(() => {
    listCoptData();
  }, []);

  // Add COPT API
  const addCoptData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("ship_id", id);
      formData.append("copt_name", data?.copt_name);
      formData.append("copt_maker", data?.copt_maker);
      formData.append("copt_model", data?.copt_model);
      formData.append("machinery_type", data?.machinery_type);
      formData.append("selected_parameters", JSON.stringify(data?.selectedParams));
      formData.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.add_copt_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("COPT Details Saved!", "COPT Details Successfully Added!");
          listCoptData();
          setIsModalOpen(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while adding COPT details:", error);
      set_loader(false);
    }
  };

  // Update COPT API
  const updateCoptData = (data) => {

    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("id", data?.id);
      formData.append("ship_id", id);
      formData.append("copt_name", data?.copt_name);
      formData.append("copt_maker", data?.copt_maker);
      formData.append("copt_model", data?.copt_model);
      formData.append("machinery_type", data?.machinery_type);
      formData.append("selected_parameters", JSON.stringify(data?.selectedParams));
      formData.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.update_copt_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", res?.message || "COPT Details Updated Successfully!");
          setIsModalOpen(false);
          listCoptData();
          if (onSuccess) onSuccess();
          set_errors({});
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while updating COPT details:", error);
      set_loader(false);
    }
  };

  // View COPT API
  const viewCoptData = (row) => {
    const formData = new FormData();
    formData.append("ship_id", id);
    formData.append("id", row?.id);
    formData.append("request_type", "view");
    try {
      post(ApiURL.view_copt_details, formData).then((res) => {
        if (res?.status === true) {
          setResponseData(res?.copt_parameters_data || {});
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      console.error("Error viewing COPT details:", error);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>COPT Information</h3>
        <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add COPT
        </Button>

        <AddCoptDetailsModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responseData?.id) {
              updateCoptData({ ...data, id: responseData.id });
            } else {
              addCoptData(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponseData({});
            set_errors({});
          }}
          responseData={responseData}
          errors={errors}
        />

        {loader ? (
          <SisLoader />
        ) : (
          <>
            {filteredData?.length > 0 ? (
              <CoptTable data={filteredData} onEdit={viewCoptData} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Copt;
